export const orderByStatusTemplate = (orderBy: string, order: string) => ({
  status: "ascNullsLast",
  [orderBy]: order,
});
